import { useContext, useMemo } from 'react';

import { LocalizationContext } from 'localization';
import { TTelegramNotificationsTypes } from 'settings';

export const useTitlesMap = (): Record<TTelegramNotificationsTypes, string> => {
  const { t } = useContext(LocalizationContext);

  return useMemo(
    () => ({
      workshifts: t('setting.notifications.types.workShift'),
      user_deposit: t('setting.notifications.types.client.deposit'),
      user_discount: t('setting.notifications.types.client.discount'),
      refund: t('setting.notifications.types.refund'),
      bonus: t('setting.notifications.types.bonus'),
      shell_status: t('setting.notifications.types.shell'),
      cash_order: t('setting.notifications.types.orders'),
      review: t('setting.notifications.types.reviews'),
      security: t('setting.notifications.types.security'),
      warehouse: t('setting.notifications.types.warehouse'),
      worker_auth: t('worker_auth'),
      low_stock: t('low_stock'),
      loyalty_program: t('setting.notifications.types.loyalty'),
      advertisement: t('setting.notifications.types.advertisement'),
    }),
    [t]
  );
};
